import classNames from 'classnames';
import React from 'react';

import styles from './H2.module.scss';

interface Props {
  alignment?: 'left' | 'center' | 'spaceBetween';
  children: React.ReactNode;
  className?: string;
  includeBorder?: boolean;
  inverted?: boolean;
}

export function H2(props: Props) {
  const { className, children, includeBorder = true, alignment = 'left', inverted = false } = props;

  return (
    <h2
      className={classNames(
        styles.root,
        styles[alignment],
        { [styles.inverted]: inverted, [styles.includeBorder]: includeBorder },
        className
      )}
    >
      {children}
    </h2>
  );
}
